
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.737 6.97l-3.839 3.845a2.918 2.918 0 11-4.13-4.124l3.844-3.85a1.751 1.751 0 012.474 2.479L6.247 9.164a.586.586 0 11-.828-.828l3.844-3.839a.586.586 0 00-.828-.828L4.597 7.513A1.75 1.75 0 007.07 9.987l3.844-3.839a2.92 2.92 0 10-4.13-4.13l-3.838 3.85a4.084 4.084 0 105.775 5.775l3.844-3.85a.583.583 0 00-.828-.816V6.97z","fill":"#9DA7B2"}})])
          )
        }
      }
    